export const DICTIONARY_TYPE = 'COA_CATEGORY';

export const COA_TOTAL_CATEGORY = 'COST_OF_ATTENDANCE';
export const COA_TOTAL_LABEL = 'Cost of Attendance';
